const { DataTable } = require("simple-datatables");
import "simple-datatables/dist/style.css";



// ---------------------------------------- Sort- and Filter-Options ----------------------------------------
const tables = document.querySelectorAll('.analysis-table');

// Loop through each table
tables?.forEach(table => {
    // Initialize the DataTable for sorting and filtering
    new DataTable(table, {
        // Labels
        labels: {
            placeholder: "Suchbegriff...", // The search input placeholder 
            searchTitle: "Tabelle durchsuchen", // The search input title 
            perPage: "Einträge pro Seite", // per-page dropdown label 
            noRows: "Es wurden keine Berichte gefunden", // Message shown when there are no records to show 
            noResults: "Für die Suche wurden keine Berichte gefunden", // Message shown when there are no search results 
            info: "{start} bis {end} von {rows} Einträgen" // 
        },

        searchable: true, // Enable search

        sortable: true, // Enable sorting

        paging: false, // Disable pagination

        // Custom sorting
        columns: [
            {
                select: 3,
                type: "date",
                format: "DD.MM.YYYY",
            },
            {
                select: 4,
                sortable: false,
            },
            {
                select: 5,
                type: "number",
                render: function (data) {
                    if (isNaN(data)) return "";
                    return Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(data);
                },
            },
            {
                select: 6,
                sortable: false,
            }
        ],
    });
});



// ---------------------------------------- Overflow ----------------------------------------
const overflowTables = document.querySelectorAll('.analysis-table-container--hidden-overflow');

// Loop through each table 
overflowTables?.forEach(table => {
    // Add a listener to the overflow toggle button
    table.querySelector('.analysis-table-overflow-toggle-btn')?.addEventListener("click", () => {
        // Remove the hidden overflow class from the table container to show all table rows
        table.classList.remove("analysis-table-container--hidden-overflow");
    });

    // If the table has a search form
    const searchForm = table.querySelector('.datatable-input');
    if (searchForm) {
        // Add event listener to the search input
        searchForm.addEventListener("input", (e) => {
            const value = e.target.value;
            // Show hidden overflow if the search input is not empty
            if (value) table.classList.remove("analysis-table-container--hidden-overflow");
        });
    }
});